import React, { FunctionComponent } from 'react';

import styled from 'styled-components';

import Typography from '@components/basics/typography';
import { Translate } from 'react-localize-redux';

interface RefLabelProps {
  className?: string;
  label: string;
  isTextLabel?: boolean;
  marginBottom?: boolean;
}

const RefLabel: FunctionComponent<RefLabelProps> = ({
  className,
  label,
  isTextLabel,
  marginBottom,
}) => {
  return (
    <Reference
      className={`${className || ''} ${marginBottom ? 'margin-bottom' : ''} ${
        !label ? 'no-margin' : ''
      }`}
    >
      {label && (
        <Typography customFont="medium" type="small" className={'text-label'}>
          {isTextLabel ? label : <Translate id={label} />}
        </Typography>
      )}
    </Reference>
  );
};

export default styled(RefLabel)`
  .text-label {
    color: grey;
    font-size: 10px;
    font-weight: 500;
    line-height: 12px;
  }
`;

const Reference = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 4px;

  &.margin-bottom {
    margin-top: 0;
    margin-bottom: 4px;
  }

  &.no-margin {
    margin: 0;
  }
`;
